export default "__VITE_ASSET__tICdiYs0__"